import React, { createContext, useCallback, useRef, useState } from 'react';
import PropTypes from 'prop-types';

/** @typedef {import('./VHPlayerEventBus.types').VHPlayerEventType} VHPlayerEventType */

export const VHPlayerEventBusContext = createContext({
  /** @type {(eventName: VHPlayerEventType, callback: () => void) => void} */
  on: (eventName, handler) => {},
  /** @type {(eventName: VHPlayerEventType, payload?: any) => void} */
  emit: (eventName, payload) => {},
});

/**
 * @type {React.FC<{children: React.ReactNode}> }
 */
export const VHPlayerEventBusProvider = ({ children }) => {
  const eventTargetRef = useRef(new EventTarget());

  const emitStopVirtualHumanTalking = useCallback(() => {
    eventTargetRef.current.dispatchEvent(
      new CustomEvent('StopVirtualHumanTalking')
    );
  }, []);

  /** @type {(eventName: VHPlayerEventType, payload?: any) => void }*/
  const emit = useCallback(
    (eventName, payload) => {
      switch (eventName) {
        case 'StopVirtualHumanTalking':
          emitStopVirtualHumanTalking();
          break;
        default:
          break;
      }
    },
    [emitStopVirtualHumanTalking]
  );

  const on = useCallback((event, handler) => {
    const listener = (/** @type {Event} **/ e) => {
      if ('detail' in e) {
        handler(e.detail);
      } else {
        handler();
      }
    };
    eventTargetRef.current.addEventListener(event, listener);
    return () => eventTargetRef.current.removeEventListener(event, listener);
  }, []);

  return (
    <VHPlayerEventBusContext.Provider
      value={{
        emit,
        on,
      }}
    >
      {children}
    </VHPlayerEventBusContext.Provider>
  );
};

VHPlayerEventBusProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default VHPlayerEventBusProvider;
